export var SERVICE_CREATION_STARTED = 'Service creation initiated';
export var SERVICE_CREATION_COMPLETED = 'Service created';
export var APPOINTMENT_CREATION_STARTED = 'Appointment creation initiated';
export var APPOINTMENT_CREATION_COMPLETED = 'Appointment booked';
export var APPOINTMENT_CHARGE_STARTED = 'Appointment charge initiated';
export var REGISTER_TRANSACTION_STARTED = 'Register transaction initiated';
export var REGISTER_TRANSACTION_COMPLETED = 'Transaction completed';
